import { ACReceiptMethodSetup } from "../../../common/lookups/Layouts/ACLayouts"

const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "Transaction Number",
        "fields": [
            {
                "name": "TransactionNumber",
                "type": "transNumSetup", "successMessage": "Setup Updated Successfully",
                "visible": true,
                "module": "OM",
                "transactionType": "S",
            },
        ]
    },
    {
        "groupId": 2,
        "label": "Freight - Shipment ID",
        "fields": [
            {
                "name": "ShipmentID",
                "type": "transNumSetup", "successMessage": "Setup Updated Successfully",
                "visible": true,
                "module": "OM",
                "transactionType": "F",
            },
        ]
    },
    {
        "groupId": 3,
        "label": "Barcode # Generation",
        "fields": [
            {
                "name": "BarcodeGeneration",
                "type": "transNumSetup", "successMessage": "Setup Updated Successfully",
                "visible": true,
                "module": "OM",
                "transactionType": "B",
            },
        ]
    },
]
const MiscLayout = [
    {
        "groupId": 1,
        "label": "OM Sales Order Entry",
        "fields": [
            {
                "name": "CREDITCOLOR",
                "tableName": "OMSETUP",
                "label": "Credit Color",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "edtColor",
                "tableName": "OMSETUP",
                "label": "Color",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true,
            },
        ]
    },
        {
        "groupId": 5,
        "label": "Split Deposit",
        "fields": [
            {
                "name": "R_RECEIPTMTHDEPOSIT",
                "tableName": "OMSETUP",
                "label": "Receipt Method",
                "type": "lookup",
                "layout": ACReceiptMethodSetup,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AUTOAPPLYSPLITDEPOSIT",
                "tableName": "OMSETUP",
                "label": "Auto Apply",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "Lot Status",
        "fields": [
            {
                "name": "UPDATEITEMSTATUS",
                "tableName": "OMSETUP",
                "label": "Update Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }]
    }, {
        "groupId": 2,
        "label": "PreCommit Security",
        "fields": [
            {
                "name": "PRECOMMITSECURITY",
                "tableName": "OMSETUP",
                "label": "PreCommit Acc",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 3,
        "label": "FB Interface",
        "fields": [
            {
                "name": "TRANSFERTRANSNOTOFB",
                "tableName": "OMSETUP",
                "label": "Transfer to FB",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 4,
        "label": "Batch Max Limit",
        "fields": [
            {
                "name": "BATCHMAXLIMIT",
                "tableName": "OMSETUP",
                "label": "Batch Max Limit",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },

    {
        "groupId": 6,
        "label": "Allocate Available Quantities",
        "fields": [
            {
                "name": "SHOWCHECKDIFFDIALOG",
                "tableName": "OMSETUP",
                "label": "Show Chk Dlg",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 7,
        "label": "Card Connect Payments",
        "fields": [
            {
                "name": "CARDCONNECTPATH",
                "tableName": "OMSETUP",
                "label": "Exe Path",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
]

export {
    PrimaryLayout,
    MiscLayout,

}